var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSplitter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6341 12.5C11.735 12.5 11.836 12.5514 11.8864 12.6028C12.0379 12.7569 12.0379 13.0138 11.8864 13.1679L8.95899 15.9936L11.8864 18.8706C12.0379 18.9734 12.0379 19.2303 11.8864 19.3844C11.735 19.5385 11.4827 19.5385 11.3312 19.3844L8.10095 16.2505C8.05047 16.1991 8 16.0963 8 15.9936C8 15.8908 8.05047 15.7881 8.10095 15.7367L11.3312 12.6541C11.4322 12.5514 11.5331 12.5 11.6341 12.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3659 19.5C20.265 19.5 20.164 19.4486 20.1136 19.3972C19.9621 19.2431 19.9621 18.9862 20.1136 18.8321L23.041 16.0064L20.1136 13.1294C19.9621 13.0266 19.9621 12.7697 20.1136 12.6156C20.265 12.4615 20.5173 12.4615 20.6688 12.6156L23.8991 15.7495C23.9495 15.8009 24 15.9037 24 16.0064C24 16.1092 23.9495 16.2119 23.8991 16.2633L20.6688 19.3459C20.5678 19.4486 20.4669 19.5 20.3659 19.5Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSplitter);
export default ForwardRef;